import React, { useEffect } from "react";
import classNames from "classnames";
import s from "../ReportGenV2.module.scss";
import { ReportPageTitle } from "../components/ReportPageTitle/ReportPageTitle";
import { ReportGrid } from "./ReportGrid";
import { observer } from "mobx-react-lite";
import { useReportBespoke } from "@iliotech/data-wire";
import { ReportPageSelect } from "../components/ReportPageSelect/ReportPageSelect";

interface Props {
  children: React.ReactNode;
  isLandscape?: boolean;
  pageId: string;
  portfolioName: string;
}

export const ReportSectionWrapper = observer(
  ({ isLandscape, pageId, portfolioName }: Props) => {
    const store = useReportBespoke();
    const generating = store.generating;
    const page = store.pages[pageId];
    const title = page?.title.replace("$portfolioName", portfolioName);
    if (!page) return null;

    return (
      <div
        className={classNames(
          s.pageWrapper,
          "keep-together",
          isLandscape && s.landscape
        )}
      >
        <ReportPageTitle
          portfolioName={portfolioName}
          value={title}
          setValue={(title) => store.updatePageTitle(pageId, title)}
        />
        <div className={s.row}>
          {!generating && (
            <div className={s.templateSelect}>
              <ReportPageSelect pageId={pageId} />
            </div>
          )}
        </div>
        <ReportGrid isLandscape={isLandscape} pageId={pageId} />
      </div>
    );
  }
);

/*  <select
            className={s.templateSelect}
            value={page.template}
            onChange={(e) =>
              store.updatePageTemplate(pageId, e.target.value as TemplateType)
            }
          >
            {Object.values(TemplateType).map((template) => (
              <option key={template} value={template}>
                {template.replace(/_/g, " ")}
              </option>
            ))}
          </select> */
